// This must be the first line in src/index.js
import 'react-app-polyfill/ie11';
// This must be the first line in src/index.js
import 'react-app-polyfill/stable';
// Must run before any date is formatted: undoes the design system's forced moment timezone
import './Config/localTimezone';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./env";


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
